import React, { memo } from 'react';

const MetricCard = memo(({ title, value, icon, onClick, cardClass, subtitle }) => (
    <div className={`metric-card ${cardClass}`} onClick={onClick}>
      <div className="metric-card-content">
        <div className="metric-icon">
          {icon}
        </div>
        <h3 className="metric-value">
          {value.toLocaleString()}
        </h3>
        <p className="metric-label">
          {subtitle}
        </p>
      </div>
    </div>
  ));

export default MetricCard;